import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { useRouter } from 'next/router';
import { DrawerOptions, DrawerAuthOption } from 'constants/index';
import { useSelector } from 'store';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { useCookies } from 'react-cookie';
import { PostLogoutAPI } from 'api/accounts';
import { accountActions } from 'store/accounts';
import { membershipActions } from 'store/membership';
import { DeleteFCMToken } from 'api/notifications';
import { makeAuthorizationConfig } from 'utils'; // Drawer 추가...

var HeaderLinks = function HeaderLinks(_ref) {
  var closeDrawer = _ref.closeDrawer;
  var router = useRouter();
  var dispatch = useDispatch();
  var path = router.pathname;
  var isLogin = useSelector(function (state) {
    return state.accounts.isLogin;
  });

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 1),
      cookies = _useCookies2[0];

  var clickLogout = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var config, fcmToken, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = makeAuthorizationConfig(cookies.access_token);
              Cookies.remove('access_token', {
                path: '/'
              });
              Cookies.remove('refresh_token', {
                path: '/'
              });
              fcmToken = localStorage.getItem('fcmToken');

              if (!fcmToken) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return DeleteFCMToken(fcmToken, config);

            case 7:
              _context.next = 9;
              return PostLogoutAPI();

            case 9:
              response = _context.sent;

              if (!(!response || response.status >= 400)) {
                _context.next = 14;
                break;
              }

              alert('로그아웃에 실패했습니다.');
              window.location.href = '/';
              return _context.abrupt("return");

            case 14:
              dispatch(accountActions.setLogout());
              dispatch(membershipActions.setLogoutMember());

              if (router.pathname === '/') {
                window.location.reload();
              } else {
                router.push('/');
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickLogout() {
      return _ref2.apply(this, arguments);
    };
  }();

  var clickRoute = function clickRoute(href) {
    router.push(href);
  };

  return /*#__PURE__*/_jsx("div", {
    className: "menu-w selected",
    children: /*#__PURE__*/_jsxs("div", {
      className: "inner",
      children: [/*#__PURE__*/_jsxs("ul", {
        className: "menu",
        children: [isLogin ? DrawerAuthOption.map(function (option, index) {
          var _option$children;

          if (option.href === path || (_option$children = option.children) !== null && _option$children !== void 0 && _option$children.some(function (child) {
            return child === path;
          })) {
            return /*#__PURE__*/_jsx("li", {
              className: "selected",
              children: /*#__PURE__*/_jsx("a", {
                onClick: function onClick() {
                  return clickRoute(option.href);
                },
                style: {
                  cursor: 'pointer'
                },
                children: option.name
              })
            }, index);
          }

          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              onClick: function onClick() {
                return clickRoute(option.href);
              },
              style: {
                cursor: 'pointer'
              },
              children: option.name
            })
          }, index);
        }) : DrawerOptions.map(function (option, index) {
          var _option$children2;

          if (option.href === path || (_option$children2 = option.children) !== null && _option$children2 !== void 0 && _option$children2.some(function (child) {
            return child === path;
          })) {
            return /*#__PURE__*/_jsx("li", {
              className: "selected",
              children: /*#__PURE__*/_jsx("a", {
                onClick: function onClick() {
                  return clickRoute(option.href);
                },
                style: {
                  cursor: 'pointer'
                },
                children: option.name
              })
            }, index);
          }

          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx("a", {
              onClick: function onClick() {
                return clickRoute(option.href);
              },
              style: {
                cursor: 'pointer'
              },
              children: option.name
            })
          }, index);
        }), isLogin ? /*#__PURE__*/_jsx("li", {
          onClick: clickLogout,
          style: {
            cursor: 'pointer'
          },
          children: /*#__PURE__*/_jsx("a", {
            children: "\uB85C\uADF8\uC544\uC6C3"
          })
        }) : null]
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "btn-close",
        onClick: closeDrawer,
        children: /*#__PURE__*/_jsx("span", {
          children: "\uBA54\uB274 \uB2EB\uAE30"
        })
      })]
    })
  });
};

export default HeaderLinks;